export default function is_empty(proof) {
    for (var i in proof) {
      return false;
    }
    return true;
  };